webModule.directive('newRvQuote', function factory() {
    return{
        templateUrl: 'app/modules/web/directives/new-rv-quote-directive.html',
        replace: true,
        transclude: false,
        restrict: 'E',
        controller: 'newRvQuoteController',
        link: function($scope, element) {
            element.on('click', 'input', function(e){
                this.select();
            });
        }
    };
});